import useThemeStore from '@/Theme/store';

/**
 * Skeleton card component for loading states
 * @returns {JSX.Element} Skeleton card
 */
const SkeletonCard = () => {
  const { theme: themeValue } = useThemeStore();

  return (
    <div
      className={`w-md flex w-full items-center justify-between flex-row ${
        themeValue === 'dark' ? 'bg-black' : 'bg-white'
      } rounded-lg overflow-hidden`}
      style={{ paddingLeft: '1.3rem' }}
    >
      <div className="bg-cool-gray dark:bg-quicksilver h-8 w-10 animate-pulse"></div>
      <div className="px-4 py-2 w-full">
        <div className="bg-cool-gray dark:bg-quicksilver h-4 w-1/2 mb-2 animate-pulse"></div>
        <div className="bg-cool-gray dark:bg-quicksilver h-4 w-1/3 animate-pulse"></div>
      </div>
    </div>
  );
};

export default SkeletonCard;
